import {
  TRaffleDrawRun,
  SmarticoRaffleWinner,
  SmarticoRaffleDraw,
  SmarticoRaffleDrawInstanceState,
  SmarticoRaffleDrawTypeExecution,
} from "../interfaces/SmarticoRaffle";
import { SmarticoRaffleDrawIds } from "../interfaces/SmarticoRaffleDrawIds";

export const USE_MOCK_DATA = false;

const now = Date.now();
const DAY_MS = 24 * 60 * 60 * 1000;

export const mockDrawsHistory: TRaffleDrawRun[] = Array.from({ length: 14 }, (_, i) => ({
  id: SmarticoRaffleDrawIds.HOURLY_DRAW,
  run_id: 1000 + i,
  name: "Daily Draw",
  description: "Win amazing prizes every day!",
  image_url: "https://placehold.co/200x200/orange/white?text=Draw",
  image_url_mobile: "https://placehold.co/100x100/orange/white?text=Draw",
  icon_url: "https://placehold.co/32x32/orange/white?text=D",
  background_image_url: "https://placehold.co/400x200/orange/white?text=BG",
  background_image_url_mobile: "https://placehold.co/200x100/orange/white?text=BG",
  is_grand: false,
  execution_ts: now - (14 - i) * DAY_MS,
  actual_execution_ts: now - (14 - i) * DAY_MS,
  ticket_start_ts: now - (15 - i) * DAY_MS,
  is_winner: i === 10,
  has_unclaimed_prize: false,
}));

export const mockFutureDraws: TRaffleDrawRun[] = Array.from({ length: 7 }, (_, i) => ({
  id: SmarticoRaffleDrawIds.HOURLY_DRAW,
  run_id: 2000 + i,
  name: "Daily Draw",
  description: "Win amazing prizes every day!",
  image_url: "https://placehold.co/200x200/gray/white?text=Future",
  image_url_mobile: "https://placehold.co/100x100/gray/white?text=Future",
  icon_url: "https://placehold.co/32x32/gray/white?text=F",
  background_image_url: "https://placehold.co/400x200/gray/white?text=BG",
  background_image_url_mobile: "https://placehold.co/200x100/gray/white?text=BG",
  is_grand: false,
  execution_ts: now + (i + 1) * DAY_MS,
  actual_execution_ts: 0,
  ticket_start_ts: now + i * DAY_MS,
  is_winner: false,
  has_unclaimed_prize: false,
}));

const usernames = [
  "LuckyPlayer77",
  "WinnerWinner",
  "JackpotJoe",
  "FortuneSeeker",
  "GoldenTicket",
  "StarGazer99",
  "MegaWinner",
  "ChampionX",
  "VictoryLap",
  "PrizeHunter",
  "BigWinBob",
  "CashKing",
  "DiamondDan",
  "EpicWinner",
  "FortuneFinder",
  "GrandPrize",
];

const prizeNames = [
  "€500 Bonus",
  "€100 Free Spins",
  "€250 Cash",
  "€50 Bonus",
  "€1000 Jackpot",
  "€75 Free Bet",
  "€200 Bonus",
  "€150 Cash",
];

const prizeImages = [
  "https://placehold.co/66x44/gold/black?text=€500",
  "https://placehold.co/66x44/purple/white?text=Spins",
  "https://placehold.co/66x44/green/white?text=€250",
  "https://placehold.co/66x44/blue/white?text=€50",
  "https://placehold.co/66x44/red/white?text=€1000",
  "https://placehold.co/66x44/teal/white?text=€75",
  "https://placehold.co/66x44/orange/white?text=€200",
  "https://placehold.co/66x44/pink/black?text=€150",
];

export const createMockWinners = (count: number = 24): SmarticoRaffleWinner[] =>
  Array.from({ length: count }, (_, i) => ({
    id: 5000 + i,
    username: usernames[i % usernames.length],
    ticket: {
      ticekt_id: 100000 + i,
      ticket_id_string: `TICKET-${100000 + i}`,
    },
    raf_won_id: 9000 + i,
    claimed_date: now - Math.floor(Math.random() * DAY_MS),
    prize: {
      id: `prize-${i}`,
      name: prizeNames[i % prizeNames.length],
      description: "Congratulations on your win!",
      image_url: prizeImages[i % prizeImages.length],
      prizes_per_run: 10,
      prizes_per_run_actual: 10,
      chances_to_win_perc: 5,
      requires_claim: false,
      min_required_tickets_for_user: 1,
      priority: 1,
      should_claim: false,
    },
  }));

const grandFinalPrizeNames = [
  "BMW M4 Competition",
  "Porsche 911 Carrera",
  "Mercedes-AMG GT",
  "Audi RS6 Avant",
  "Range Rover Sport SVR",
  "Tesla Model S Plaid",
  "Lamborghini Huracán",
];

const grandFinalUsernames = [
  "SpeedDemon_UK",
  "LuckyLarry88",
  "DreamRacer",
  "BigWinBetty",
  "TurboTom",
  "PrizeQueen99",
  "GoldenGoose7",
];

const grandFinalPrizeImages = [
  "https://placehold.co/66x44/gold/black?text=BMW",
  "https://placehold.co/66x44/silver/black?text=911",
  "https://placehold.co/66x44/black/white?text=AMG",
  "https://placehold.co/66x44/darkgreen/white?text=RS6",
  "https://placehold.co/66x44/navy/white?text=RR",
  "https://placehold.co/66x44/red/white?text=Tesla",
  "https://placehold.co/66x44/orange/white?text=Lambo",
];

export const mockGrandDrawWinners: SmarticoRaffleWinner[] = grandFinalUsernames.map((username, i) => ({
  id: i + 1,
  username,
  ticket: {
    ticekt_id: 900000 + i,
    ticket_id_string: `GRAND-${900000 + i}`,
  },
  raf_won_id: 80000 + i,
  claimed_date: now - Math.floor(Math.random() * DAY_MS),
  prize: {
    id: `grand-prize-${i}`,
    name: grandFinalPrizeNames[i],
    description: "Grand Final Prize",
    image_url: grandFinalPrizeImages[i],
    prizes_per_run: 7,
    prizes_per_run_actual: 7,
    chances_to_win_perc: 1,
    requires_claim: false,
    min_required_tickets_for_user: 1,
    priority: i + 1,
    should_claim: false,
  },
}));

export const mockWinnersByRunId: Record<number, SmarticoRaffleWinner[]> = {
  ...mockDrawsHistory.reduce(
    (acc, draw) => {
      acc[draw.run_id] = createMockWinners(Math.floor(Math.random() * 20) + 8);
      return acc;
    },
    {} as Record<number, SmarticoRaffleWinner[]>
  ),
  [SmarticoRaffleDrawIds.GRAND_DRAW]: mockGrandDrawWinners,
};

export const mockPaginationByRunId: Record<
  number,
  { winners_total: number; winners_limit: number; winners_offset: number }
> = Object.fromEntries(
  Object.entries(mockWinnersByRunId).map(([runId, winners]) => [
    runId,
    { winners_total: 6000, winners_limit: winners.length, winners_offset: 0 },
  ])
);

export const mockActiveDraw: SmarticoRaffleDraw = {
  id: SmarticoRaffleDrawIds.HOURLY_DRAW,
  run_id: mockDrawsHistory[mockDrawsHistory.length - 1].run_id,
  name: "Daily Draw",
  description: "Win amazing prizes every day!",
  image_url: "https://placehold.co/200x200/orange/white?text=Draw",
  image_url_mobile: "https://placehold.co/100x100/orange/white?text=Draw",
  icon_url: "https://placehold.co/32x32/orange/white?text=D",
  background_image_url: "https://placehold.co/400x200/orange/white?text=BG",
  background_image_url_mobile: "https://placehold.co/200x100/orange/white?text=BG",
  is_grand: false,
  prizes: [],
  current_state: SmarticoRaffleDrawInstanceState.Executed,
  execution_type: SmarticoRaffleDrawTypeExecution.Recurring,
  execution_ts: now,
  ticket_start_ts: now - DAY_MS,
  allow_multi_prize_per_ticket: false,
  total_tickets_count: 5000,
  my_tickets_count: 10,
  my_last_tickets: [],
  winners_limit: 10,
  winners_offset: 0,
  winners_total: 10,
};
